import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useEffect, useCallback } from 'react';
import '../../../../../../../authentication/context/AuthenticationProvider.js';
import '@geit/ui-components';
import { useAppConfig } from '../../../../../../../authentication/hooks/useAppConfig.js';
import { useCurrentUser } from '../../../../../../../authentication/hooks/useCurrentUser.js';
import { useNavigate } from '../../../../../../../authentication/hooks/useNavigate.js';
import { usePermission } from '../../../../../../../authentication/hooks/usePermission.js';
import { useToken } from '../../../../../../../authentication/hooks/useToken.js';
import '../../../../../../../authentication/navigate.js';
import { getEshopBRNs } from '../../../../../../../authentication/helpers/utils.js';
import 'styled-components';
import theme from '../../../../../theme/index.js';
import { transformMenuUrl } from '../../../../../helpers/utils.js';
import ListItem from '../ListItem.js';
import { onServiceClick } from '../service.js';
import DesktopSubMenu from './DesktopSubMenu.js';
import { SDHeader, SCAnchorBlackPrimary, SDHeaderText, SDBorder, SubDesktop, SDSubItemMainContainer, SDSubMenuContext } from './styles.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const menuId = "sub_menu_context";
const DesktopMenu = _ref => {
  let {
    baseUrl,
    menuItems = [],
    menuHoverKey,
    onMenuMouseEnter,
    onMenuMouseLeave,
    theme: theme$1,
    onClickMenu
  } = _ref;
  var _a;
  const {
    getPermission
  } = usePermission("", void 0, true);
  const {
    fetchToken
  } = useToken();
  const config = useAppConfig();
  const {
    user
  } = useCurrentUser();
  const currentBRN = (_a = user.entitySelection) == null ? void 0 : _a.refNumber;
  const [eshopBRNs, setEshopBRNs] = useState([]);
  useEffect(() => {
    getEshopBRNs(config).then(res => {
      setEshopBRNs(res);
    });
  }, [config]);
  const [subMenuHoverKey, setSubMenuHoverKey] = useState(-1);
  const navigate = useNavigate();
  const onSubMenuMouseEnter = useCallback(key => {
    setSubMenuHoverKey(key);
  }, []);
  const onSubMenuMouseLeave = useCallback(key => {
    setSubMenuHoverKey(key);
  }, []);
  const onMouseEnter = useCallback(key => {
    onMenuMouseEnter(key);
    setSubMenuHoverKey(-1);
  }, []);
  const onMouseLeave = useCallback(key => {
    const node = document.getElementById(menuId);
    if (node) {
      node.style.height = "0px";
    }
    onMenuMouseLeave(key);
  }, []);
  return menuItems.map((menuItem, key) => {
    var _a2;
    const haveSubMenu = menuItem.subMenu && menuItem.subMenu.length > 0;
    const showSubMenu = menuHoverKey === key && haveSubMenu;
    let href = menuItem.item.external ? menuItem.item.href : baseUrl + menuItem.item.href;
    href = transformMenuUrl({
      url: href,
      isEShopMenu: menuItem.item.isEShopMenu,
      eshopBRNs,
      currentBRN,
      featureCode: menuItem.item.featureCode,
      sector: (_a2 = user.entitySelection) == null ? void 0 : _a2.sector
    });
    return /* @__PURE__ */jsxs(ListItem, {
      onMouseEnter: () => onMouseEnter(key),
      onMouseLeave: () => onMouseLeave(key),
      children: [/* @__PURE__ */jsx(SDHeader, {
        children: /* @__PURE__ */jsx(SCAnchorBlackPrimary, {
          href: href === "" ? "#" : href,
          theme: theme$1,
          onClick: e => onServiceClick({
            e,
            menuItem: __spreadProps(__spreadValues({}, menuItem), {
              item: __spreadProps(__spreadValues({}, menuItem.item), {
                href
              })
            }),
            currentBRN,
            navigate,
            config,
            fetchToken,
            getPermission,
            close: () => onMouseLeave(-1)
          }),
          children: /* @__PURE__ */jsxs(SDHeaderText, {
            tag: "div",
            color: theme.colours.white,
            type: "smallBody",
            children: [menuItem.item.title, menuHoverKey === key && /* @__PURE__ */jsx(SDBorder, {})]
          })
        })
      }), haveSubMenu && /* @__PURE__ */jsx(SubDesktop, {
        "data-testid": "SecondaryDesktop",
        visible: showSubMenu,
        children: /* @__PURE__ */jsx(SDSubItemMainContainer, {
          children: /* @__PURE__ */jsx(SDSubMenuContext, {
            id: menuId,
            children: /* @__PURE__ */jsx(DesktopSubMenu, {
              subMenuItems: menuItem.subMenu,
              menuHoverKey: subMenuHoverKey,
              onMenuMouseEnter: onSubMenuMouseEnter,
              onMenuMouseLeave: onSubMenuMouseLeave,
              theme: theme$1,
              title: menuItem.item.title,
              parentId: menuId,
              baseUrl,
              close: () => onMouseLeave(-1),
              eshopBRNs,
              onClickMenu
            })
          })
        })
      })]
    }, key);
  });
};
export { DesktopMenu as default };